import { Stack, Typography, Box } from "@mui/material";
import { convertBitsToBytes } from "../../../../../../utils/easyMaps/convertToBytes";

// Componente para exibir informações de tráfego
const TrafficContent = ({
  outPutTrafficData,
  inPutTrafficData,
  host,
  interfaceName,
  styles,
}) => (
  <Stack style={styles.stackPopup}>
    <Typography style={styles.titlePopup}>{host}</Typography>
    <Typography style={{ ...styles.titlePopup, ...styles.colorTextLayer }}>
      {"[ " + interfaceName + " ]"}
    </Typography>
    <br />
    <TrafficRow
      label="TX:"
      value={outPutTrafficData.valor}
      unit={outPutTrafficData.unidade}
      styles={styles}
    />
    <TrafficRow
      label="RX:"
      value={inPutTrafficData.valor}
      unit={inPutTrafficData.unidade}
      styles={styles}
    />
  </Stack>
);

// Componente para exibir informações de potência
const PowerContent = ({ txPower, rxPower, host, interfaceName, styles }) => (
  <Stack style={styles.stackPopup}>
    <Typography style={styles.titlePopup}>{host}</Typography>
    <Typography style={{ ...styles.titlePopup, ...styles.colorTextLayer }}>
      {"[ " + interfaceName + " ]"}
    </Typography>
    <br />
    <TrafficRow label="TX:" value={txPower} unit="dBm" styles={styles} />
    <TrafficRow label="RX:" value={rxPower} unit="dBm" styles={styles} />
  </Stack>
);

// Componente  para linha de dados
const TrafficRow = ({ label, value, unit, styles }) => (
  <Box
    style={{
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
    }}
  >
    <Typography style={{ ...styles.fontPopup, ...styles.colorTextLayer }}>
      {label}
    </Typography>
    <Box style={styles.boxInfo}>
      <Typography style={styles.fontPopup}>{value ?? "N/A"}</Typography>
      <Typography style={{ ...styles.fontPopup, ...styles.colorTextLayer }}>
        {unit}
      </Typography>
    </Box>
  </Box>
);

// Componente principal
const PopupContent = ({ variant, connectionData, host, theme }) => {
  const interfaceName = connectionData?.interface || "Desconhecido";
  const styles = {
    fontPopup: {
      margin: "0px",
      fontSize: "12px",
      fontWeight: 500,
      color: theme.palette.color.textEasyMaps,
    },
    colorTextLayer: {
      color: theme.palette.text.primary,
      fontWeight: 600,
    },
    titlePopup: {
      margin: "0px",
      fontSize: "12px",
      fontWeight: 500,
      color: theme.palette.color.textEasyMaps,
      width: "100%",
      textAlign: "center",

      whiteSpace: "normal",
      overflow: "hidden",
      textOverflow: "ellipsis",
      display: "-webkit-box",
      WebkitLineClamp: 2, // Limite de 2 linhas
      WebkitBoxOrient: "vertical",
    },
    boxInfo: {
      display: "flex",
      flexDirection: "row",
      gap: "3px",
    },
    stackPopup: {
      width: "200px",
    },
  };

  if (variant === "trafego") {
    const outPutTrafficData = convertBitsToBytes(connectionData?.tx_traffic);
    const inPutTrafficData = convertBitsToBytes(connectionData?.rx_traffic);

    return (
      <TrafficContent
        outPutTrafficData={outPutTrafficData}
        inPutTrafficData={inPutTrafficData}
        host={host}
        interfaceName={interfaceName}
        styles={styles}
      />
    );
  }

  if (variant === "potencia") {
    return (
      <PowerContent
        txPower={connectionData?.tx_power}
        rxPower={connectionData?.rx_power}
        host={host}
        interfaceName={interfaceName}
        styles={styles}
      />
    );
  }

  return null;
};

export default PopupContent;
